import { BaseSerializer } from "./baseSerializer.ts";
import {TodoSection} from "@models/todo_section.model.ts";
import {TodoSerializer} from "@models/serializers/todoSerializer.ts";


export class TodoSectionSerializer extends BaseSerializer {

    public deserialize( data: any ): TodoSection {

        const todo_section = new TodoSection();
        this._copyAttributes(todo_section, data);

        if (data.todos) {
            const todoSerializer = new TodoSerializer();
            todo_section.todos = todoSerializer.deserializeList(data.todos);
        }

        return todo_section;
    }

}
